import { useEffect, useState } from 'react';
import { useTranslation } from '@/store/languageStore';
import {
  dashboardGreetingKey,
  dayPartFromHour,
  formatGreetingDate,
  greetingFirstName,
} from '@/utils/dashboardGreeting';

type DashboardGreetingProps = {
  firstName?: string | null;
};

const DashboardGreeting = ({ firstName }: DashboardGreetingProps) => {
  const { t, i18n } = useTranslation();
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    const id = window.setInterval(() => setNow(new Date()), 60_000);
    return () => window.clearInterval(id);
  }, []);

  const name = greetingFirstName(firstName);
  const key = dashboardGreetingKey(dayPartFromHour(now.getHours()), name.length > 0);
  const greeting = name.length > 0 ? t(key, { name }) : t(key);

  return (
    <div className="min-w-0">
      <p className="text-sm text-textSecondary">{formatGreetingDate(now, i18n.language)}</p>
      <h1 className="truncate text-3xl font-bold leading-tight text-textDefault">{greeting}</h1>
    </div>
  );
};

export default DashboardGreeting;
